import * as React from 'react';
import { useState, useEffect } from 'react';
import { API } from '../../../services/amplifyCompat';
import { Box, Typography, CircularProgress } from '@mui/material';
import { BaseComponent } from '../../../prop-types/component';
import useTranslation from '../../../components/customHooks/translations';
import { getAllQuizzes } from '../../../graphql/queries';
import { useActionFactImage } from '../../../hooks/use-action-fact-image';
import { ResponseError } from '../ResponseError';

export const SubjectFact = () => {
  const { signup } = useTranslation();
  const [quiz, setQuiz] = useState(null);
  const [noPossibleQuizzes, setNoPossibleQuizzes] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchQuiz = async () => {
      try {
        setLoading(true);
        setError(null);
        const getAllQuizzesFact = await API.graphql({
          query: getAllQuizzes,
        });

        const quizPool = getAllQuizzesFact.data.getAllQuizzes;
        if (quizPool?.length > 0) {
          const randomQuiz =
            quizPool[Math.floor(Math.random() * quizPool.length)];
          setQuiz(randomQuiz);
        } else {
          setNoPossibleQuizzes(true);
        }
      } catch (e) {
        console.log('Error fetching quizzes: ', e);
        setError(e?.message || 'Failed to load fact. Please try again.');
      } finally {
        setLoading(false);
      }
    };

    fetchQuiz();
  }, []);

  const { randomImage, isLoading: imageLoading } = useActionFactImage();

  const renderFact = () => {
    if (loading) {
      return <CircularProgress aria-label="Loading quizzes" />;
    }
    if (error) {
      return <ResponseError error={error} />;
    }
    if (quiz) {
      return (
        <Typography variant="p" component="p" sx={{ lineHeight: '1.5' }}>
          {quiz.fact_text}
        </Typography>
      );
    }
    if (noPossibleQuizzes) {
      return (
        <Typography variant="p" component="p" sx={{ lineHeight: '1.5' }}>
          No facts available right now.
        </Typography>
      );
    }
    return null;
  };

  return (
    <Box data-testid="subject-fact">
      {randomImage ? (
        <figure
          style={{
            position: 'relative',
            margin: '1.5rem auto 2rem',
            maxWidth: '342px',
          }}
        >
          <img
            height="250px"
            src={randomImage['Thumb228']}
            alt={randomImage?.title}
            style={{ borderRadius: '1.5rem 1.5rem 0 0', maxWidth: '100%' }}
          />
          <figcaption
            style={{
              position: 'relative',
              bottom: '0',
              right: '0',
              color: 'white',
              fontSize: '14px',
              background: '#0F172A',
              padding: '0.5em',
              width: '100%',
              borderRadius: '0 0 1.5rem 1.5rem',
              boxSizing: 'border-box',
              marginTop: '-10px',
            }}
          >
            Photo by {randomImage['Artist']} from {randomImage['Country']}
          </figcaption>
        </figure>
      ) : imageLoading ? (
        <CircularProgress aria-label="Loading image" />
      ) : null}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          textAlign: 'center',
          alignItems: 'center',
        }}
      >
        <Typography variant="h1" mb=".5em">
          {signup.subjectFactHeading}
        </Typography>
        {renderFact()}
      </Box>
    </Box>
  );
};

SubjectFact.propTypes = {
  ...BaseComponent,
};
